import React from 'react'
import { Box, Typography } from '@mui/material';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { options } from '../../../contentful-options';
import { useParams } from "react-router-dom";
import useReport from '../../../utils/useReport';

export default function Overview() {
  let params = useParams();
  const reportId = params.reportId;

  const { data, error, isLoading } = useReport({ reportId });

  if (error) {
    console.log(error)
    return <div>failed to load </div>
  }

  if (isLoading) {
    return (
      <Typography>Loading...</Typography>
    )
  }

  if (!data) {
    return (
      <Typography>No Data Present</Typography>
    )
  }

  const { overview } = data;

  if (overview === undefined) {
    return (
      <Typography>Error fetching the Overview</Typography>
    )
  }

  return (
    <Box>
      {documentToReactComponents(overview, options)}
    </Box>
  );
}
